import { render, staticRenderFns } from "./AboutUsNav.vue?vue&type=template&id=3b5996ca&scoped=true&"
import script from "./AboutUsNav.vue?vue&type=script&lang=js&"
export * from "./AboutUsNav.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsNav.vue?vue&type=style&index=0&id=3b5996ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5996ca",
  null
  
)

export default component.exports